module.exports = __webpack_public_path__ + "static/media/segSzklo.e8376d7a.png";